import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeDark from './pages/dark/Home';
import Blogs from './pages/dark/blogs';
import Works from './pages/dark/works';
import SingleProject from './pages/dark/single-project';
import SingleBlog from './pages/dark/single-blog';
import ChatModal from "./components/Common/Chatmodal";

function App() {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/" element={<HomeDark />} />
          <Route path="/dark" element={<HomeDark />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/works" element={<Works />} />
          <Route path="/single-project/:id" element={<SingleProject />} />
          <Route path="/single-blog" element={<SingleBlog />} />
        </Routes>

        {/* ✅ Global floating AI Chat */}
        <ChatModal />
      </>
    </Router>
  );
}

export default App;
